// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreator from "@modules/reporting/actionCreator";
import type { AbsenceReviewTask } from "@modules/shared/reducer/absence-review/types";
import AbsenceReviewForm from "./absence-review-form";

type OwnProps = $Exact<{
  task: ?AbsenceReviewTask,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const AbsenceReviewView = (props: Props) => (
  <AbsenceReviewForm task={props.task} disabled externalSubmit />
);

export default localize()(AbsenceReviewView);
